<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <div v-if="isExist('PILJUR')" class="alert alert-success">
      <strong>Pilihan Anda</strong>
      <div v-if="constraint.max_all > 0">Pilihan Max. {{ constraint.max_all }}</div>
      <ul style="margin-left: 17px">
        <li v-for="(item, i) in model.pilihan_all" :key="item.id">
          Pilihan {{ i + 1 }} - {{ getProdiName(item) }} - {{ getKelasName(model.kelas) }}
        </li>
      </ul>
      <button v-if="options.switch" class="btn btn-default" style="margin-top: 20px;" @click="inverseHide">
        {{ options.hide_msg }}
      </button>
    </div>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="!options.hide_pilihan" v-if="isExist('PILJUR')" :class="{'form-group': true, 'has-error': errors.has('kelas')}">
        <label class="col-md-3"><span class="required-label">*</span>Pilihan Kelas</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kelas"
            class="form-control"
            v-model="model.kelas"
            v-validate="isExist('PILJUR') ? 'required' : ''"
            v-on:change="() => onChangeKelas()"
          >
            <option value="null" hidden>Pilihan Kelas</option>
            <option v-for="kelas in options.kelas" :value="kelas.id_kelas" :key="kelas.id">
              {{ kelas.kelas.nama_kelas }}
            </option>
          </select>
          <span v-show="errors.has('kelas')" class="error-label">Pilih Kelas</span>
        </div>
      </div>

      <div v-show="!options.hide_pilihan" v-if="isExist('PILJUR')" :class="{'form-group': true, 'has-error': errors.has('pilihan_all')}">
        <label class="col-md-3"><span class="required-label">*</span>Pilihan Jurusan</label>
        <div class="col-md-9">
          <div v-for="(item, index) in options.dataFilter" :key="index">
            <strong v-if="index == 0"
              style="padding: 0px">
              {{ item.program_studi.fakultas.nama_fakultas }}
              <br>
              <br>
            </strong>
            <input type="checkbox"
              name="pilihan_all"
              :id="`checkboxitem${item.id_prodi}`"
              :value="item.id_prodi"
              v-model="model.pilihan_all"
              v-validate="isExist('PILJUR') ? 'required' : ''"
              @click="() => checkLimit(`checkboxitem${item.id_prodi}`)">
            <label :for="`checkboxitem${item.id_prodi}`">{{ item.program_studi.nama_prodi }}</label>
            <div v-if="options.dataFilter.length-1 != index">
              <br v-if="item.program_studi.fakultas.id_fakultas != options.dataFilter[index+1].program_studi.fakultas.id_fakultas">
              <strong v-if="item.program_studi.fakultas.id_fakultas != options.dataFilter[index+1].program_studi.fakultas.id_fakultas"
                style="padding: 0px">
                {{ options.dataFilter[index+1].program_studi.fakultas.nama_fakultas }}
                <br>
                <br>
              </strong>
            </div>
          </div>
          <span v-show="errors.has('pilihan_all')" class="error-label">Pilih Jurusan</span>
        </div>
      </div>

      <div v-show="isExist('LOKASI')" :class="{'form-group': true, 'has-error': errors.has('lokasi_ujian')}">
        <label class="col-md-3"><span class="required-label">*</span>Lokasi Ujian, Tanggal Ujian</label>
        <div class="col-md-9">
          <select
            type="text"
            name="lokasi_ujian"
            class="form-control"
            v-model="model.lokasi_ujian"
            v-validate="isExist('LOKASI') ? 'required' : ''"
          >
            <option value="null" hidden>Pilihan Lokasi Ujian, Tanggal Ujian</option>
            <option v-for="jadwal in options.jadwal" :id="`optionjadwal${jadwal.kode_jadwal}`" :key="jadwal.id"
              :value="jadwal.kode_jadwal">
                {{ getJadwalLabel(jadwal) }}
            </option>
          </select>
          <span v-show="errors.has('lokasi_ujian')" class="error-label">Pilih Lokasi Ujian, Tanggal Ujian</span>
        </div>
      </div>
    </form>
    <div v-if="kodeJalur == 13 || kodeJalur == 23">* Peserta Non Tes hanya menunggu pengumuman di laman web https://admisi.uin-suka.ac.id dan tidak perlu hadir saat tanggal/hari ujian berlangsung.</div>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import Options from '@/helper/options'

export default {
  data () {
    return {
      loading: false,
      sending: false,
      model: {
        kelas: null,
        pilihan_all: [],
        lokasi_ujian: null
      },
      constraint: {
        max_saintek: 0,
        max_soshum: 0,
        max_campuran: 0,
        max_all: 0,
        min_saintek: 0,
        min_soshum: 0,
        min_campuran: 0,
        min_all: 0
      },
      options: {
        kelas: [],
        jadwal: [],
        data: [],
        dataFilter: [],
        hide_pilihan: false,
        switch: false,
        hide_msg: 'Ubah'
      }
    }
  },
  computed: {
    isDisable () {
      return this.$store.getters.getAuthData.isDisable
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    kodePenawaran () {
      return this.$store.getters.getAuthData.data.mhs_jalur.kode_penawaran
    },
    kodeJalur () {
      return this.$store.state.auth.data.mhs_jalur.penawaran_jalur.kode_jalur
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(22).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                this.flash('gagal menyimpan data', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              if (this.model.pilihan_all.length < this.constraint.min_all) {
                reject({message: 'isikan pilihan sampai pilihan ke-'+this.constraint.min_all})
              }
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (!this.options.hide_pilihan) {
          let pilihanJurusanSender = Promise.resolve(this.sendDataPilihanjurusan())
          let jadwalUjianSender = Promise.resolve(this.sendDataJadwalUjian())
          this.sending = false
          Promise.all([pilihanJurusanSender, jadwalUjianSender]).then((success) => {
            success[0] && success[1] ? resolve(true) : reject(false)
          })
        } else {
          let jadwalUjianSender = Promise.resolve(this.sendDataJadwalUjian())
          jadwalUjianSender.then((success) => {
            this.sending = false
            success ? resolve(true) : reject(false)
          })
        }
      })
    },
    sendDataPilihanjurusan () {
      return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV !== 'test') {
          api.post('/v2/pilihan_jurusan/many', {
            nomor_pendaftar: this.nomorPendaftar,
            id_prodi: this.model.pilihan_all,
            kode_jalur: this.$store.state.auth.data.mhs_jalur.penawaran_jalur.kode_jalur,
            tahun_daftar: this.$store.state.auth.data.mhs_jalur.penawaran_jalur.tahun,
            id_jenjang: this.$store.state.auth.data.mhs_jalur.penawaran_jalur.jalur.id_jenjang,
            id_kelas: this.model.kelas
          })
            .then(response => {
              resolve(true)
            })
            .catch(e => {
              resolve(false)
            })
        } else {
          resolve(true)
        }
      })
    },
    sendDataJadwalUjian () {
      return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV !== 'test') {
          api.post('/v2/pilih_jadwal', {
            nomor_pendaftar: this.nomorPendaftar,
            kode_jadwal: this.model.lokasi_ujian
          })
            .then(response => {
              resolve(true)
            })
            .catch(e => {
              resolve(false)
            })
        } else {
          resolve(true)
        }
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 22)
    },
    async initData () {
      this.getDataPenawaranJurusan()
      this.getDataPenawaranKelas()
      this.getDataPenawaranMinat()
      let optionsJadwal = await Options.getOptionsLokasiUjian(this.kodePenawaran, this.isDisable)
      this.options.jadwal = optionsJadwal.filter((item) => {
        if (item.detail_jadwal.length > 0) {
          let today = new Date(new Date().toLocaleString('en', {timeZone: 'Asia/Jakarta'}))
          let startDate = new Date(item.detail_jadwal[0].tanggal)
          today.setHours(0, 0, 0, 0)
          startDate.setHours(0, 0, 0, 0)
          if (((startDate - today) / (1000 * 60 * 60 * 24)) > 1) {
            return true
          } else {
            return false
          }
        }
        return true
      })
      // force user to always choose test date
      // this.getDataPilihJadwal()
    },
    inverseHide () {
      if (this.options.hide_pilihan) {
        this.options.hide_pilihan = false
        this.model.pilihan_all = []
        this.options.hide_msg = 'Batal'
      } else {
        this.options.hide_pilihan = true
        this.getDataPilihanJurusan()
        this.options.hide_msg = 'Ubah'
      }
    },
    checkLimit (elid) {
      let el = document.getElementById(elid)
      if (this.model.pilihan_all.length === this.constraint.max_all) {
        el.checked = false
      }
      scroll(0, 0)
    },
    getProdiName (kode) {
      let prodi = this.options.data.filter(data => data.id_prodi === kode)
      if (prodi[0].program_studi) {
        return prodi[0].program_studi.nama_prodi
      } else {
        return 'Not Found'
      }
    },
    getKelasName (kode) {
      let prodi = this.options.kelas.filter(data => data.id_kelas === kode)
      return prodi[0].kelas.nama_kelas
    },
    getJadwalLabel (item) {
      let schedule1 = '(Belum ada detail jadwal)'
      let schedule2 = ''
      if (item.detail_jadwal.length > 0) {
        schedule1 = item.detail_jadwal[0].tanggal
        schedule2 = item.detail_jadwal[item.detail_jadwal.length - 1].tanggal
      }
      let schedule = ''
      schedule1 === schedule2 ? schedule = schedule1 : schedule = `${schedule1} s/d ${schedule2}`
      switch (item.status_penuh) {
        case 1:
          return `${item.lokasi_ujian}, ${schedule} (RUANGAN PENUH)`
        case 2:
          return `${item.lokasi_ujian}, ${schedule} (BELUM ADA RUANGAN)`
        default:
          return `${item.lokasi_ujian}, ${schedule} (RUANGAN TERSEDIA)`
      }
    },
    getDataPilihanJurusan () {
      this.loading = true
      api.get('/v2/pilihan_jurusan/' + this.nomorPendaftar)
        .then(response => {
          let success = response.data.success
          if (success) {
            let data = response.data.data
            this.model.pilihan_all = []
            this.model.kelas = data[0].id_kelas
            this.options.dataFilter = this.options.data.filter(data => data.id_kelas === this.model.kelas)
            data.forEach(element => {
              let item = this.options.data.filter(data => data.id_prodi === element.id_prodi && data.id_kelas === element.id_kelas)
              this.model.pilihan_all.push(item[0].id_prodi)
            })
            this.options.hide_pilihan = true
            this.options.switch = true
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    getDataPilihJadwal () {
      api.get('/v1/pilih_jadwal/' + this.nomorPendaftar)
        .then(response => {
          let success = response.data.success
          if (success) {
            this.model.lokasi_ujian = response.data.data.kode_jadwal
          }
        })
    },
    getDataPenawaranJurusan () {
      api.get('/v2/penawaran_jurusan_by_kode_penawaran/' + this.kodePenawaran)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.options.data = data
            this.getDataPilihanJurusan()
          }
        })
    },
    getDataPenawaranKelas () {
      api.get('/v2/kelas_jalur_by_kode_penawaran/' + this.kodePenawaran)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.options.kelas = data
          }
        })
    },
    getDataPenawaranMinat () {
      api.get('/v2/penawaran_minat_by_kode_penawaran/' + this.kodePenawaran)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            data.forEach(element => {
              switch (element.kode_minat) {
                case '1':
                  this.constraint.max_saintek = element.jumlah_penawaran
                  this.constraint.min_saintek = element.jumlah_minimum_pengisian
                  break
                case '2':
                  this.constraint.max_soshum = element.jumlah_penawaran
                  this.constraint.min_soshum = element.jumlah_minimum_pengisian
                  break
                case '3':
                  this.constraint.max_campuran = element.jumlah_penawaran
                  this.constraint.min_campuran = element.jumlah_minimum_pengisian
                  break
              }
            })
            this.constraint.max_all = this.constraint.max_saintek + this.constraint.max_soshum + this.constraint.max_campuran
            this.constraint.min_all = this.constraint.min_saintek + this.constraint.min_soshum + this.constraint.min_campuran
            if (this.constraint.min_all === 0) {
              this.constraint.min_all = 1
            }
          }
        })
    },
    onChangeKelas () {
      this.model.pilihan_all = []
      this.options.dataFilter = this.options.data.filter(data => data.id_kelas === this.model.kelas)
      for (let i = 0; i < this.options.dataFilter.length; i++) {
        for (let j = 0; j < this.options.dataFilter.length; j++) {
          let el1 = this.options.dataFilter[i]
          let el2 = this.options.dataFilter[j]
          let haveToChange = el1.program_studi.id_fakultas > el2.program_studi.id_fakultas
          if (haveToChange) {
            this.options.dataFilter[i] = el2
            this.options.dataFilter[j] = el1
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataPilihanJurusan.vue